<template>
  <div>
    <h5 v-if="label" class="text-primary">{{ label }}</h5>
    <div v-html="html">

    </div>
  </div>
</template>

<script>
export default {
  name : "textDisplay",
  props: ["html", "label"],
  beforeUpdate() {
    const {$el}                                     = this
    const className                                 = $el.className;
    $el.className                                   = ""
    $el.children[$el.children.length - 1].className = className
  }
}
</script>

<style scoped>
.ql-editor {
  font-size: 13px;
  min-height: 0;
  background-color: #eee;
}
</style>